module.exports = __webpack_public_path__ + "static/media/saudiarabia.9f8e63cb.svg";